import apiHandler from '../apiHandler';
import { METHOD } from '../constants';
import { OrderHistoryInfo } from '../types';
import { PATHS } from '../utils';

const fetchVinInfo = async (
  authorization: string,
  requestPayload: any
): Promise<OrderHistoryInfo[]> => {
  const response = await apiHandler({
    url: PATHS.GET_ORDERDETAILS,
    method: METHOD.POST,
    headers: { authorization },
    reqObj: requestPayload
  });
  if (!response.ok) throw new Error(response.statusText);

  return (await response.json()) as Promise<OrderHistoryInfo[]>;
};

export default fetchVinInfo;